import { z } from 'zod';

export const SkillEntry = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  // Phoenix's skill descriptions are nullable, and no rule reads one.
  description: z.string().nullable(),
});

export type SkillEntry = z.infer<typeof SkillEntry>;

// The skills registry is a flat object keyed by slug → entry.
export const SkillsRegistry = z.record(z.string(), SkillEntry);

export type SkillsRegistry = z.infer<typeof SkillsRegistry>;
